import {
	selectRiskDetailsTablePage,
	selectorRiskDetailsRows,
} from '@Selectors/Risk.selectors';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { useSelector } from 'react-redux';

export default function useRiskDetailsRows() {
	const tablePage = selectRiskDetailsTablePage();
	const isIndividualScoresEnabled = useIsFeatureEnabled(
		'info-360-risk-datagrid-individual-scores',
	);

	const risks = useSelector(selectorRiskDetailsRows);

	const rows =
		tablePage.cells.map((row: string[], nRow: number) => {
			const WEIGHTED_SCORES = risks[nRow].WEIGHTED_SCORES;

			return {
				id: nRow,
				ASSET_ID: row[0],
				RISK_CHANGE: row[1],
				CURRENT_RISK: row[2],
				CURRENT_LOF: row[3],
				CURRENT_COF: row[4],
				CONDITION_DATA: row[5],
				GRADE: row[6],
				Menu: row[0],
				...(isIndividualScoresEnabled && WEIGHTED_SCORES),
			};
		}) || [];

	return rows;
}
